import $ from 'jquery';

export default class ProductExport {
  constructor($scope, $timeout) {
    $scope.export = function(mode) {
      $timeout(function() {
        $('form#getXLS input[name="mode"]').val(mode);
        $('form#getXLS').submit();
      }, 300);
    };
  }
}

ProductExport.$inject = ['$scope', '$timeout'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/product-export.ctrl.js